import InviteApplicationPage from "./InviteApplicationPage";
export default InviteApplicationPage;
